//IP SQL API CONNECTION
import config from "./config/config";

async function getFromAPI(
  table,
  queries = "",
  maxDelay = 120000,
  getDeleted = false
) {
  const entorno =
    table === "Enviroments" ? "all" : localStorage.env;
  let query;
  if (!getDeleted) {
    query = `?deletedAt=null`;
    if (queries !== "") {
      query = `?deletedAt=null&${queries}`;
    }
  } else {
    query = `?${queries}`;
  }

  const abortController = new AbortController();
  const _timeout = setTimeout(() => {
    abortController.abort();
  }, maxDelay);

  const url = `${config.apiSQL}:${config.portSQL}/${table}/${entorno}${query}`;
  const options = { signal: abortController.signal };

  try {
    const res = await fetch(url, options);
    const parsedRes = await res.json();
    if (parsedRes) {
      clearTimeout(_timeout);
    }
    if (!parsedRes.error) {
      return parsedRes.data;
    } else {
      const errObj = {
        type: "GET API SQL",
        status: res.status,
        message: res.message ? res.message : "No definido",
      };
      return Promise.reject(errObj);
    }
  } catch (e) {
    clearTimeout(_timeout);
    const errObj = {
      type: "GET API SQL",
      message: e.message ? e.message : "No definido",
    };
    if (e.name === "AbortError") {
      errObj.message = `No hubo respuesta del servidor en ${maxDelay}ms`;
    }
    return Promise.reject(errObj);
  }
}

async function putToAPI(
  entorno,
  table,
  body,
  fromERP = true,
  maxDelay = 120000
) {
  try {
    const bodyJSON = body ? JSON.stringify(body) : null;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (bodyJSON === null) {
      return Promise.reject("El body no puede estar vacio");
    }

    const abortController = new AbortController();
    const _timeout = setTimeout(() => {
      abortController.abort();
    }, maxDelay);

    const url = `${config.apiSQL}:${config.portSQL}/${table}/${entorno}`;
    const options = {
      method: "PUT",
      headers: myHeaders,
      body: bodyJSON,
      redirect: "follow",
      signal: abortController.signal,
    };

    const res = await fetch(url, options);
    const parsedRes = await res.json();
    if (parsedRes) {
      clearTimeout(_timeout);
    }
    if (!parsedRes.error) {
      return parsedRes;
    } else {
  
      return Promise.reject({
        response: true,
        message: parsedRes.message ? res.message : "No definido",
        sql: parsedRes.msgSQL ? res.msgSQL : "No definido"
      });
    }
  } catch (e) {
    return Promise.reject({
      response: false,
      e: e
    });
  }
}

async function postToAPI(
  entorno,
  table,
  body,
  fromERP = true,
  maxDelay = 40000,
  kiriTable = false
) {
  // return await new Promise(resolve => setTimeout(resolve, 3000));
  try {
    const bodyJSON = body ? JSON.stringify(body) : null;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (bodyJSON === null) {
      return Promise.reject("El body no puede estar vacio");
    }

    const abortController = new AbortController();
    const _timeout = setTimeout(() => {
      abortController.abort();
    }, maxDelay);

    // const url = `localhost:3000/${table}/${entorno}`;
    const url = kiriTable ?`${config.apiSQL}:${config.portSQL}/kiri/${table}/${entorno}` :`${config.apiSQL}:${config.portSQL}/${table}/${entorno}`;

    const options = {
      method: "POST",
      headers: myHeaders,
      body: bodyJSON,
      redirect: "follow",
      signal: abortController.signal,
    };

    const res = await fetch(url, options); 
    const parsedRes = await res.json();
    if (parsedRes) {
      clearTimeout(_timeout);
    }

    if (!parsedRes.error) {
      return parsedRes;
    } else {
  
      return Promise.reject({
        response: true,
        message: parsedRes.message ? parsedRes.message : "No definido",
        sql: parsedRes.msgSQL ? parsedRes.msgSQL : "No definido"
      });
    }
  } catch (e) {
    return Promise.reject({
      response: false,
      message: e.toString()
    });
  }
}

async function deleteAllFromAPI({entorno, table, maxDelay = 15000}) {

  let _timeout;
  try {
    const abortController = new AbortController();
    _timeout = setTimeout(() => {
      abortController.abort();
    }, maxDelay);

    const url = `${config.apiSQL}:${config.portSQL}/xlsx/${table}/${entorno}`;
    const options = {
      method: "DELETE",
      signal: abortController.signal,
    };

    const res = await fetch(url, options);
    const parsedRes = await res.json();
    if (parsedRes) {
      clearTimeout(_timeout);
    }
    if (!parsedRes.error) {
      return parsedRes;
    } else {
  
      return Promise.reject({
        response: true,
        message: parsedRes.message ? res.message : "No definido",
        error: parsedRes.errorMsg,
        sql: parsedRes.msgSQL ? res.msgSQL : "No definido"
      });
    }
  } catch (e) {
    clearTimeout(_timeout)
    return Promise.reject({
      response: false,
      e: e.message
    });
  }

}

async function deleteFromAPI(
  entorno,
  table,
  body,
  fromERP = true,
  maxDelay = 120000
) {
  try {
    const bodyJSON = body ? JSON.stringify(body) : null;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (bodyJSON === null) {
      return Promise.reject("El body no puede estar vacio");
    }

    const abortController = new AbortController();
    const _timeout = setTimeout(() => {
      abortController.abort();
    }, maxDelay);

    const url = `${config.apiSQL}:${config.portSQL}/${table}/${entorno}`;
    const options = {
      method: "DELETE",
      headers: myHeaders,
      body: bodyJSON,
      redirect: "follow",
      signal: abortController.signal,
    };

    const res = await fetch(url, options);
    const parsedRes = await res.json();
    if (parsedRes) {
      clearTimeout(_timeout);
    }
    if (!parsedRes.error) {
      return parsedRes;
    } else {
  
      return Promise.reject({
        response: true,
        message: parsedRes.message ? res.message : "No definido",
        sql: parsedRes.msgSQL ? res.msgSQL : "No definido"
      });
    }
  } catch (e) {
    return Promise.reject({
      response: false,
      e: e
    });
  }
}

export { getFromAPI, postToAPI, putToAPI, deleteFromAPI, deleteAllFromAPI };
